module.exports = __webpack_public_path__ + "static/img/shff.24741d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shff.png
// module id = SVvk
// module chunks = 1